module.exports = __webpack_public_path__ + "static/media/paintCanDefault.553ae037.png";